import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'TechJobs',
    description: 'Technology jobs collected daily from company career pages, a live resume builder, and match scores that explain how well you fit each role.',
    tagline: 'Every tech job, straight from the source',
    url: getOrigin()
}
